import { Link } from "react-router-dom";
import { BRAND } from "@/data/content";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div data-testid="auth-shell" className="relative min-h-screen bg-white text-neutral-900 flex flex-col overflow-hidden">
      {/* Ambient aurora orbs - subtle accents only */}
      <div aria-hidden className="absolute inset-0 pointer-events-none z-0">
        <div
          className="aurora-orb aurora-orb-magenta orb-anim-a"
          style={{ width: 380, height: 380, top: -120, left: -120, opacity: 0.16 }}
        />
        <div
          className="aurora-orb aurora-orb-azure orb-anim-b"
          style={{ width: 340, height: 340, bottom: -120, right: -100, opacity: 0.14 }}
        />
      </div>

      <header className="relative z-10 border-b border-neutral-200/70">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-6 lg:px-12 h-16 sm:h-20 flex items-center justify-between">
          <Link to="/" data-testid="auth-logo" className="flex items-baseline gap-2 sm:gap-3">
            <span className="font-serif text-lg sm:text-2xl tracking-tight text-neutral-900">
              {BRAND.wordmark.lead}
            </span>
            <span className="font-serif italic text-lg sm:text-2xl text-aurora">
              {BRAND.wordmark.tail}
            </span>
          </Link>
          {footer}
        </div>
      </header>

      <main className="relative z-10 flex-1 flex items-center justify-center px-5 sm:px-6 py-12 sm:py-20">
        <div className="w-full max-w-md glass rounded-md p-8 sm:p-10">
          <p className="overline">{title}</p>
          <h1 className="font-serif text-4xl sm:text-5xl tracking-tight leading-[1.05] mt-3 sm:mt-4">
            {subtitle}
          </h1>
          <div className="mt-8 sm:mt-10">{children}</div>
        </div>
      </main>
    </div>
  );
}
